import FormHeader from '../../components/forms/FormHeader';
import { NavigateFunction, useNavigate } from 'react-router-dom';

const NicknameRequestSent = () => {
  const navigate: NavigateFunction = useNavigate();

  return (
    <>
      <FormHeader
        title={`Demande envoyée !`}
        subTitle={`Si votre compte a bien été créé et confirmé, une demande de réinitialisation de votre identifiant vous a été envoyée par e-mail.`}
        subSubTitle={`Vérifiez dans votre boite mail que votre compte a bien été créé et confirmé.`}
      />
      <div onClick={() => navigate(`/login`)} className='text-green-secondary mt-3 cursor-pointer text-center font-bold hover:underline'>
        Retour à la page de connexion
      </div>
    </>
  );
};

export default NicknameRequestSent;
